import { ng } from '@uirouter/angularjs/lib/angular';
import { IHttpPromise } from 'angular';
import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { EnumService } from '../../../app.common/modules/common/services/enum.service';
import { TransferFileService } from '../../../app.common/modules/common/services/transferFile.service';
import { RetailerService } from '../api/retailer.service';
import { IReadingLocationVariationsStatistics } from '../model/dpp-analytics/reading-location-variations-statistics.interface';
import { IVariationsReportRequest } from '../model/dpp-analytics/variations-report-request.interface';

export class DppAnalyticsService {
  public static $inject = ['retailerService', 'http', 'transferFileService', 'enumService', '$http'];

  constructor(
    private retailerService: RetailerService,
    private http: HttpService,
    private transferFileService: TransferFileService,
    private enumService: EnumService,
    private $http: ng.IHttpService
  ) {
  }

  public getVariationsReport(body: IVariationsReportRequest): IHttpPromise<IReadingLocationVariationsStatistics> {
    return this.$http.post<IReadingLocationVariationsStatistics>(this.retailerService.variationsReport(), body);
  }

  public exportToCsv(rows: string[][], fileName: string) {
    let csvContent = '';

    rows.forEach((rowArray) => {
      const row = rowArray.join(';');
      csvContent += row + '\r\n';
    });
    this.transferFileService.transferFile(csvContent, fileName, this.enumService.ExportFileType.CSV);
  }
}

angular
  .module('naut')
  .service('dppAnalyticsService', DppAnalyticsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/dpp-analytics/dpp-analytics.service.ts